export function isDefined(val) {
    return val !== undefined && val !== null;
}
